import { Rect, RectZero, RectFromString } from '@archipad-js/core/utils';
import { decodeUserCommentExif } from '@core/types';
import { parse } from 'exifr';

export const enum SizeHint {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
}

export const enum DrawingHint {
    DRAWING_UNKNOWN = 0,
    DRAWING_NO = 1,
    DRAWING_MIXED = 2,
    DRAWING_ONLY = 3,
}

export async function parseRect(img: Blob): Promise<Rect> {
    const parsing = await parse(img, {
        pick: ['UserComment']
    });

    if(!parsing || !parsing.userComment){
        return RectZero();
    }

    const decode = decodeUserCommentExif(parsing.userComment);

    return RectFromString(decode);
}